import React, { FC } from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

interface ConfirmationModalProps {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

/**
 * StyledDialog is the container for our Modal with a glass effect on the Paper.
 * It also applies a blurred black backdrop outside the modal.
 */
const StyledDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiPaper-root': {
		background: 'rgba(255, 255, 255,1)',
		backdropFilter: 'blur(14px)',
		WebkitBackdropFilter: 'blur(14px)',
		boxShadow: 'none',
		border: 'none',
		borderRadius: '20px',
	},
	'& .MuiBackdrop-root': {
		backdropFilter: 'blur(10px)', // Adjust blur as needed
		WebkitBackdropFilter: 'blur(10px)',
		backgroundColor: 'rgba(0, 0, 0, 0.5)', // Adjust to make it darker/lighter
	},
}));

/**
 * For a "Contained" or "Outlined" GlassButton look, we replicate simplified styles here.
 */
const GlassButton = styled(Button)<{ variant: 'contained' | 'outlined' }>(
	({ variant }) => ({
		...(variant === 'contained' && {
			backgroundColor: '#36454F',
			boxShadow: 'none',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#2b3a41',
				boxShadow: 'none',
			},
			'&:disabled': {
				backgroundColor: '#2b3a4155',
				boxShadow: 'none',
				color: '#fff',
			},
		}),
		...(variant === 'outlined' && {
			backgroundColor: 'transparent',
			color: '#36454F',
			border: '1px solid #36454F',
			boxShadow: 'none',
			'&:hover': {
				backgroundColor: 'rgba(54, 69, 79, 0.08)',
			},
			'&:disabled': {
				backgroundColor: '#2b3a4155',
				boxShadow: 'none',
				color: '#fff',
			},
		}),
	}),
);

const ConfirmationModal: FC<ConfirmationModalProps> = ({
	open,
	onConfirm,
	onCancel,
}) => {
	return (
		<StyledDialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
			<DialogTitle sx={{ textAlign: 'center' }}>Confirmation</DialogTitle>
			<DialogContent>
				<Typography variant="body1" sx={{ mb: 2 }}>
					Create the agent now.
				</Typography>
			</DialogContent>
			<DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
				<GlassButton variant="outlined" onClick={onCancel} size="large">
					Cancel
				</GlassButton>
				<GlassButton
					variant="contained"
					onClick={onConfirm}
					size="large"
				>
					Save
				</GlassButton>
			</DialogActions>
		</StyledDialog>
	);
};

export default ConfirmationModal;
